import React, { useEffect, useState } from 'react';
import { FormControl, TextField, Box } from '@mui/material';
import RegularButton from 'components/CustomButtons/Button';
import { AutocompleteComponent } from 'components/Autocomplete/AutocompleteComponent';
import { useForm } from 'hooks/useForm';
import { useDispatch, useSelector } from 'react-redux';
import { assignIotDevice } from 'redux/actions/iotDevices/iotDevicesActions';
import { getAllTanksByStation } from 'views/ComoData/getOptions';
import { useSearch } from 'hooks/useSearch';

const INITIAL = { station: '', idTank: '', startDate: '', observations: '' };
const RULES = { station: { required: true }, idTank: { required: true }, startDate: { required: true } };

export const IotDeviceAssignForm = ({ onClose }) => {
  const dispatch = useDispatch();
  const { iotDeviceSelected } = useSelector(({ iotDevices }) => iotDevices);
  const { stationsList } = useSelector(({ companies }) => companies);
  const deviceStation = stationsList.find(s => s.id === iotDeviceSelected?.idStation) ?? '';
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { setSnackbar } = useSearch();
  const [tanksOptions, setTanksOptions] = useState([]);
  const [loadingTanks, setLoadingTanks] = useState(false);

  const { values, onChange, validate, errors, setValues } = useForm(
    { station: deviceStation, idTank: '', startDate: '', observations: '' },
    RULES
  );

  useEffect(() => {
    if (!values.station?.id) {
      setTanksOptions([]);
      setValues({ idTank: '' });
      return;
    }
    const load = async () => {
      setLoadingTanks(true);
      setValues({ idTank: '' });
      const tanks = await getAllTanksByStation(setSnackbar, values.station.id);
      setTanksOptions(tanks);
      setLoadingTanks(false);
    };
    load();
    // eslint-disable-next-line
  }, [values.station?.id]);

  const handleSubmit = () => {
    validate([], () => {
      dispatch(assignIotDevice(
        iotDeviceSelected.id,
        { idTank: values.idTank?.id, startDate: values.startDate, observations: values.observations },
        onClose,
      ));
    });
  };

  return (
    <FormControl fullWidth style={{ display: 'flex', gap: 12, marginTop: 16 }}>
      <AutocompleteComponent
        name="station"
        value={values.station}
        options={stationsList}
        label="Planta *"
        handleValues={setValues}
        textFieldProps={{ error: !!errors.station, helperText: errors.station }}
        disabled
      />
      <AutocompleteComponent
        name="idTank"
        value={values.idTank}
        options={tanksOptions}
        loading={loadingTanks}
        label="Tanque comodato *"
        handleValues={setValues}
        disabled={!values.station?.id}
        textFieldProps={{ error: !!errors.idTank, helperText: errors.idTank }}
      />
      <TextField
        label="Fecha de inicio *"
        name="startDate"
        type="date"
        value={values.startDate}
        onChange={onChange}
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        error={!!errors.startDate}
        helperText={errors.startDate}
      />
      <TextField
        label="Observaciones"
        name="observations"
        value={values.observations}
        onChange={onChange}
        variant="outlined"
        multiline
        rows={3}
      />
      <Box display="flex" justifyContent="space-between" mt={2}>
        <RegularButton color="danger" onClick={onClose}>Cancelar</RegularButton>
        <RegularButton
          color="info"
          onClick={handleSubmit}
          disabled={isLoadingComp?.loadingIotDevices}
        >
          Vincular
        </RegularButton>
      </Box>
    </FormControl>
  );
};
